<template>
  <div class="saved">
    <adx-sidebar />
    <div class="saved__main container-router">
      <div class="saved__main__header desktop">
        <h2 class="medium-title">Saved</h2>
        <button class="btn-regular primary" @click="toogleModal(1)">Create New</button>
      </div>
      <div class="saved__main__header mobile">
        <h2 class="medium-title">Saved</h2>
      </div>
      <loading v-if="isLoading" slot="loading" />
      <div v-else class="saved__main__content">
        <saved-card v-for="(saved, index) in saveds" :key="index" :saved="saved"
        :color="setColor(index)" :items="menuItems.campaign" :addtionalItems="menuItems.collection" @selected="selectOption" @setSaved="setSaved"/>
      </div>
    </div>
    <modal v-if="isShown" @modal-close="toogleModal(0)" type='small' :noTitle="true">
      <div v-if="modalTitle === 'Delete this Folder ?'" class="saved__main__new" slot="content">
        <h2 class="small-title">Delete Folder</h2>
        <p>Are you sure want to remove folder {{selectedSaved.title}} and all its listing item ? </p>
        <p>Note : this action can’t be undo. </p>
        <div class="saved__main__new__buttons">
          <span class="color-red" >{{error}}</span>
          <button class="btn-regular secondary" @click="toogleModal(0)">Cancel</button>
          <button ref="save" class="loading" :class="{active:isLoadingModal}" @click="deleteFolder">
            <span> Delete </span>
            <loading-spin v-if="isLoadingModal" slot="loading" />
          </button>
        </div>
      </div>
      <div v-else-if="modalTitle != ''" class="saved__main__new" slot="content">
        <div class="saved__main__new__input">
          <input ref="input" type="text" @keyup="KeyUp" :value="newTitle" :class="titleError ? 'error' : ''" required>
          <label v-if="modalTitle === 'Rename Folder'" class="subhead" :class="{load:isLoadingModal}">
            Folder Name
          </label>
          <label v-else class="subhead" :class="{load:isLoadingModal}">
            Folder Name
          </label>
          <span v-if="titleError" class="saved__main__new__input__error small-font">Ensure this field has no more than 191 characters.</span>
        </div>
        <div v-if="modalTitle === 'Create Folder'" class="saved__main__new__buttons">
          <span class="color-red" >{{error}}</span>
          <button class="btn-regular secondary" @click="toogleModal(0)">Cancel</button>
          <button ref="save" class="loading" :class="{active:isLoadingModal}"
          :disabled="newTitle === '' || titleError" @click="createFolder">
            <span> Save </span>
            <loading-spin v-if="isLoadingModal" slot="loading" />
          </button>
        </div>
        <div v-if="modalTitle === 'Rename Folder'" class="saved__main__new__buttons">
          <span class="color-red" >{{error}}</span>
          <button class="btn-regular secondary" @click="toogleModal(0)">Cancel</button>
          <button ref="save" class="loading" :class="{active:isLoadingModal}"
          :disabled="newTitle === '' || titleError" @click="renameFolder">
            <span> Save </span>
            <loading-spin v-if="isLoadingModal" slot="loading" />
          </button>
        </div>
      </div>
    </modal>
    <!-- <modal v-if="isShownCampaign" :noTitle="true" @modal-close="isShownCampaign = false" :type="isMobile ? 'small' : ''">
      <div class="saved__main__campaign" slot="content">
        <h2 class="small-title">Add to campaign</h2>
        <button class="btn-block primary" @click="createCampaign">
          Create new campaign
          <div class="primary__load">
            <loading-spin slot="loading"/>
          </div>
        </button>
        <div class="saved__main__campaign__break">
          <span>OR</span>
        </div>
        <h2 class="small-title">Add to current campaign</h2>
        <div class="load">
          <loading v-if="isLoadingCampaign" slot="loading" />
        </div>
        <ul class="saved__main__campaign__list">
          <li v-for="(item, index) in campaigns" :key="index" @click="appendCampaign(item.id)" class="saved__main__campaign__list__item">
            <p> {{item.title}} </p>
            <div class="saved__main__campaign__list__item__load">
              <loading-spin-red v-if="isLoadingAppend" slot="loading"/>
            </div>
          </li>
        </ul>
      </div>
    </modal> -->
    <div class="saved__main__header mobile">
      <fab @clicked="toogleModal(1)" />
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/SideBar/Desktop'
import SavedCard from '@/components/Card/SavedCard'
import Modal from '@/components/Modal'
import FAB from '@/components/FAB'
import Loading from '@/components/Loading/Primary'
import LoadingSpinRed from '@/components/Loading/Secondary'
import LoadingSpin from '@/components/Loading/Secondary-white'
import api from '@/api/'
import { apiV2 } from '@/api/urls'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-saved',
  components: {
    'adx-sidebar': Sidebar,
    'saved-card': SavedCard,
    'fab': FAB,
    Loading,
    LoadingSpin,
    LoadingSpinRed,
    Modal,
    Loading,
  },
  head: {
    title: {
      inner: 'Saved',
    }
  },
  data() {
    return {
      saveds: [],
      campaigns: [],
      collections: [],
      isLoading: true,
      isLoadingCampaign: true,
      isLoadingAppend: [],
      isLoadingModal: false,
      isLoadingCreate: false,
      isMobile: window.innerWidth < 769,
      isShown: false,
      isShownCampaign: false,
      selectedSaved: null,
      newTitle: '',
      titleError: false,
      modalTitle: '',
      error: '',
      newCampaign: true,
    }
  },
  computed: {
    ...mapGetters ({
      isSuperuser: 'isSuperuser'
    }),
    menuItems: function () {
      const items = {
        campaign: this.campaigns
      }
      if (this.isSuperuser) items['collection'] = this.collections
      return items
    }
  },
  mounted() {
    this.getSaveds()
    this.getCampaigns()
    if (this.isSuperuser) {
      this.getCollections()
    }
  },
  watch: {
    newTitle: function (newValue, oldValue) {
      if (newValue.length > 191) {
        this.titleError = true
      } else {
        this.titleError = false
      }
    }
  },
  methods: {
    getSaveds() {
      (async () => {
        this.isLoading = true
        const { data } = await api.get(apiV2.saved, { needToken: true })
        this.saveds = data.map(el => {
          return {
            id: el.id,
            title: el.title,
            item: el.item_count,
            is_default: el.is_default
          }
        })
         this.isLoading = false
      })();
    },
    setColor(index){
      index ++
      if(index % 6 == 0) return '#5856D6'
      else if(index % 6 == 5) return '#3BB04F'
      else if(index % 6 == 4) return '#49A3CC'
      else if(index % 6 == 3) return '#CC2F26'
      else if(index % 6 == 2) return '#FF9500'
      else if(index % 6 == 1) return '#FF2D55'
    },
    toDetail() {

    },
    setSaved(saved) {
      this.selectedSaved = saved
    },
    selectOption(item) {
      if (item.value == 'campaign') {
        if (item.items.value == 'add') {
          this.createCampaign()
        } else {
          this.appendCampaign(item.items.value)
        }
      }
      if (item.value == 'collection') {
        if (item.items.value == 'add') {
          this.createCollection()
        } else {
          this.appendCollection(item.items.value)
        }
      }
      if (item.value == 'rename') this.toogleModal(2)
      if (item.value == 'duplicate') this.duplicateFolder()
      if (item.value == 'delete') this.toogleModal(4)
    },
    showCampaign(){
      // this.isShownCampaign = true
      // this.getCampaigns()
    },
    getCampaigns() {
      if (this.campaigns.length == 0){
        (async () => {
          this.isLoadingCampaign = true
          const response = await api.get(apiV2.draftCampaigns, { needToken: true })
          this.isLoadingCampaign = false
          if (response.status == 200) {
            // this.campaigns = response.data
            this.campaigns.push({
              "name": "Create new campaign",
              "value": "add"
            })
            response.data.map(el => {
              this.campaigns.push({
                "name": el.title,
                "value": el.id
              })
            })
          } else {
            // this.error = response.data.error
          }
        })();
      }
    },
    getCollections() {
      (async () => {
        this.isLoadingCampaign = true
        const response = await api.get(apiV2.collectionMenu, { needToken: true })
        this.isLoadingCampaign = false
        if (response.status == 200) {
          // this.campaigns = response.data
          this.collections.push({
            "name": "Create new collection",
            "value": "add"
          })
          this.collections = this.collections.concat(response.data.map(el => {
            return {
              name: el.name,
              value: el.value
            }
          }))
        } else {
          // this.error = response.data.error
        }
      })();
    },
    appendCampaign(id) {
      (async () => {
        this.isLoadingAppend.push(id)
        const data = {
          channel_name: 'saved',
          list_channel_id: [this.selectedSaved.id]
        }
        const response = await api.patch(apiV2.campaignAddBulkListing(id), data, { needToken: true })
        this.isLoadingAppend = []
        if (response.status == 200) {
          this.$router.push({ path: `/${id}/campaign-editor` })
        } else {
          this.error = response.data.error
        }
      })();
    },
    appendCollection(id) {
      (async () => {
        this.isLoadingAppend.push(id)
        const data = {
          channel_name: 'saved',
          list_device_id: [this.selectedSaved.id]
        }
        const response = await api.patch(apiV2.collectionAddBulkDevice(id), data, { needToken: true })
        this.isLoadingAppend = []
        if (response.status == 200) {
          this.$router.push({ name: `collectioneditor`, params: { id: id } })
        } else {
          this.error = response.data.error
        }
      })();
    },
    createCampaign() {
      (async () => {
        this.isLoadingCreate = true
        const data = {
          campaign_channel: [
            {
              name: 'saved',
              list_id: [this.selectedSaved.id]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isLoadingCreate = false
        if (response.status == 201) {
          this.$router.push({ name: 'campaigneditorpage', params: { id: response.data['data']['id'], newCampaign: this.newCampaign }})
        } else {
          this.error = response.data.error
        }
      })();
    },
    createCollection() {
      (async () => {
        this.isLoadingCreate = true
        const data = {
          channel_name: 'saved',
          list_device_id: [this.selectedSaved.id]
        }
        const response = await api.post(apiV2.collection, {}, { needToken: true })
        if (response.status == 201) {
          const collectionId = response.data.id
          const responseAdd = await api.patch(apiV2.collectionAddBulkDevice(collectionId), data, { needToken: true })
          this.isLoadingCreate = false
          if (responseAdd.status == 200) {
            this.$router.push({ name: `collectioneditor`, params: { id: collectionId } })
          } else {
            this.error = responseAdd.data.error
          }
        } else {
          this.error = response.data.error
        }
      })();
    },
    toogleModal(number) {
      if (!this.isLoadingModal) {
        if (number == 1) {
          this.modalTitle = 'Create Folder'
        } else if (number == 2) {
          this.modalTitle = 'Rename Folder'
          this.newTitle = this.selectedSaved.title
        } else if (number == 4) {
          this.modalTitle = 'Delete this Folder ?'
        } else if (number == 0) {
          this.modalTitle = ''
          this.newTitle = ''
          this.error = ''
        }
        this.isShown = !this.isShown
      }
    },
    KeyUp(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        if (this.modalTitle == 'Create Folder') this.createFolder()
        if (this.modalTitle == 'Rename Folder') this.renameFolder()
      }
    },
    createFolder(){
      (async () => {
        this.isLoadingModal = true
        this.$refs.save.disabled = true
        const data = {
          title: this.newTitle
        }
        const response = await api.post(apiV2.saved, data, { needToken: true })
        this.isLoadingModal = false
        if (response.status == 201) {
          this.saveds.push({
            id: response.data.id,
            title: response.data.title,
            item: response.data.item_count,
            is_default: response.data.is_default
          })
          this.toogleModal(0)
        } else {
          this.error = response.data.error
        }
      })();
    },
    renameFolder(){
      (async () => {
        this.isLoadingModal = true
        this.$refs.save.disabled = true
        const data = {
          title: this.newTitle
        }
        const response = await api.put(apiV2.savedDetail(this.selectedSaved.id), data, { needToken: true })
        this.isLoadingModal = false
        if (response.status == 200) {
          this.saveds.map((value) => {
            if (value.id == this.selectedSaved.id) {
              value.title = this.newTitle
            }
          })
          this.toogleModal(0)
        } else {
          this.error = response.data.error
        }
      })();
    },
    duplicateFolder(){
      (async () => {
        this.isLoading = true
        const response = await api.post(apiV2.savedDuplicate(this.selectedSaved.id), {}, { needToken: true })
        if (response.status == 201) {
          this.getSaveds()
        }
      })();
    },
    deleteFolder() {
      (async () => {
        this.isLoadingModal = true
        this.$refs.save.disabled = true
        const response = await api.destroy(apiV2.savedDetail(this.selectedSaved.id), { needToken: true })
        this.isLoadingModal = false
        if (response.status == 204) {
          this.getSaveds()
          this.toogleModal(0)
        } else {
          this.error = response.data.error
        }
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>